import React, { FC, useEffect, useState } from "react";
import { Descriptions } from "antd";
import moment from "moment";
import "./lotteryInfo.scss";
import { useSelector } from "react-redux";
import { ILotteryData } from "../../types/Staking";
import { RootState } from "../../store/store";

export const LotteryInfoTable: FC<ILotteryData> = ({
  projectId,
  projectName,
  tickets,
  createdDate,
  isWhiteListed,
  whiteListCreated,
  ticketToTokenMultiplier,
}) => {
  const { claimInfo } = useSelector((s: RootState) => s.homePage);
  const [claimedTickets, setClaimedTickets] = useState(0);

  useEffect(() => {
    let claimedTicketsTemp = 0;
    claimInfo.map((n) => {
      if (n.Title === projectName) {
        claimedTicketsTemp += n.claimAmount;
      }
      return true;
    });
    setClaimedTickets(claimedTicketsTemp);
  }, [claimInfo, projectName]);

  return (
    <>
      <div className="table-size">
        <Descriptions
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}
          bordered
        >
          <Descriptions.Item className="lottery-row-size" label="Project ID">
            {projectId}
          </Descriptions.Item>
          <Descriptions.Item className="lottery-row-size" label="Project Name">
            {projectName}
          </Descriptions.Item>
          <Descriptions.Item
            className="lottery-row-size"
            label="Tickets amount"
          >
            {tickets}
          </Descriptions.Item>
          <Descriptions.Item
            className="lottery-row-size"
            label="Project Created Date"
          >
            {moment(createdDate).format("YYYY/MM/DD HH:mm")}
          </Descriptions.Item>
          <Descriptions.Item label="Whitelisted">
            {isWhiteListed}
          </Descriptions.Item>
          <Descriptions.Item
            className="lottery-row-size"
            label="Whitelist Joined Date"
          >
            {moment(whiteListCreated).format("YYYY/MM/DD HH:mm")}
          </Descriptions.Item>
          <Descriptions.Item
            className="lottery-row-size"
            label="Tickets To Token Ratio"
          >
            {ticketToTokenMultiplier}
          </Descriptions.Item>
          <Descriptions.Item
            className="lottery-row-size"
            label="Already Claimed"
          >
            {claimedTickets}
          </Descriptions.Item>
        </Descriptions>
        <div />
      </div>
    </>
  );
};
